export default __webpack_public_path__ + "static/media/Door.666a7fa5.png";